<form class="kt-form" autocomplete="off">

    <div *ngIf="email != '' && !pinEnvoye?.message" class="alert alert-solid-info alert-bold" role="alert">
        <div class="alert-text">
            Le code de sécurité a été envoyé à votre adresse : {{email}}
        </div>
    </div>

    <div *ngIf="pinEnvoye?.message" class="alert alert-solid-{{pinEnvoye.ok ? 'success':'danger'}} alert-bold"
         role="alert">
        <div class="alert-text">
            <span>{{pinEnvoye.message}}</span>
        </div>
    </div>

    <div class="row">
        <div class="col"><input (paste)="onPaste($event)" (keypress)="changed(pin2)" maxlength="1" #pin1 class="pin"
                                matInput autocomplete="off"/></div>
        <div class="col"><input (paste)="onPaste($event)" (keypress)="changed(pin3)" maxlength="1" #pin2 class="pin"
                                matInput autocomplete="off"/></div>
        <div class="col"><input (paste)="onPaste($event)" (keypress)="changed(pin4)" maxlength="1" #pin3 class="pin"
                                matInput autocomplete="off"/></div>
        <div class="col"><input (paste)="onPaste($event)" (keypress)="changed(pin5)" maxlength="1" #pin4 class="pin"
                                matInput autocomplete="off"/></div>
        <div class="col"><input (paste)="onPaste($event)" (keypress)="changed(pin6)" maxlength="1" #pin5 class="pin"
                                matInput autocomplete="off"/></div>
        <div class="col"><input (paste)="onPaste($event)" (keypress)="changed(btn)" maxlength="1" #pin6 class="pin"
                                matInput autocomplete="off" /></div>
    </div>

    <!--begin::Action-->
    <div class="kt-login__actions">
        <a  href="javascript:;" (click)="renvoyerPin()" class="kt-link kt-login__link-forgot">
            Renvoyer le code de sécurité ?
            <i *ngIf="pinLoading" class="kt-spinner kt-spinner--brand"></i>
        </a>

        <button #btn [disabled]="loading || notValide" (click)="confirmer()"
                [ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading}"
                id="kt_login_signin_submit" class="btn btn-primary btn-elevate kt-login__btn-primary">
            Confirmer
        </button>
    </div>
    <!--end::Action-->
</form>
